import React, { FC } from 'react';
import './styles/clan.css';

import { ClanProps } from './types';

export const Clan: FC<ClanProps> = ({ img, text }) => {
    return (
        <div className='clanContainer'>
            <img src={img} />
            <p>{text}</p>
        </div>
    );
};
